import {View} from 'react-native';
import React from 'react';
import {useStyles} from '../../hooks/styles';
import {Props} from './model';
// import {hexToRgbA} from '../../pipes/color';
// import {GradientView} from '../gradientView';
// import {useTheme} from '../../theme';
// import {ServicesContentSimple} from '../content';
// import {Text} from '../text';

// const LoginPreloader = () => {
//   const theme = useTheme();
//   const styles = useStyles(() => ({
//     container: {
//       width: '100%',
//       height: '100%',
//     },
//   }));
//   return (
//     <GradientView
//       style={styles.container}
//       gradient={{angle: 90, colors: theme.screen.bgGradient.map((color) => hexToRgbA(color, 0.9))}}
//     />
//   );
// };

// const MainPreloader = () => {
//   const theme = useTheme();
//   const styles = useStyles(() => ({
//     container: {
//       width: '100%',
//       height: '100%',
//     },
//     header: {
//       paddingVertical: 5,
//       ...theme.header.container,
//       justifyContent: 'center',
//       alignItems: 'center',
//     },
//     headerTitle: {
//       textAlign: 'center',
//       ...theme.fonts.h6,
//       color: theme.color.textColor,
//     },
//     welcome: {
//       ...theme.fonts.h6,
//       color: theme.color.primaryNonGreyBackground,
//       paddingVertical: 18,
//       textAlign: 'center',
//     },
//     sectionContainer: {
//       marginTop: Platform.select({android: 10, ios: 10, web: 32}),
//       paddingHorizontal: 24,
//       marginBottom: 50,
//     },
//     sectionTitleMobile: {
//       ...theme.fonts.h6,
//       textAlign: 'center',
//       marginBottom: 28,
//     },
//   }));
//   return (
//     <View style={styles.container}>
//       <SafeAreaView>
//         <View style={styles.header}>
//           <Text style={styles.headerTitle}>{'Единая социальная карта\nСвердловской области'}</Text>
//         </View>
//         <GradientView gradient={{angle: 90, colors: theme.welcome.bgGradient.map((color) => hexToRgbA(color, 0.9))}}>
//           <Text style={styles.welcome}>Здравствуйте!</Text>
//         </GradientView>
//         <View style={styles.sectionContainer}>
//           <Text style={styles.sectionTitleMobile}>Возможности карты</Text>
//           <ServicesContentSimple />
//         </View>
//       </SafeAreaView>
//     </View>
//   );
// };

const EmptyPreloader = () => {
  return <View />;
};

export default ({type}: Props) => {
  const styles = useStyles(() => ({
    container: {flex: 1, alignItems: 'center', justifyContent: 'center'},
  }));
  const children = (() => {
    switch (type) {
      case 'login': {
        return <EmptyPreloader />; // <LoginPreloader />;
      }
      default: {
        return <EmptyPreloader />; // <MainPreloader />
      }
    }
  })();
  return <View style={styles.container}>{children}</View>;
};
